<script>
    import UserItem from "./UserItem.svelte";
    import {getOrganizations, getRoles, getUsers} from "../firestore";

    let users = []

    let organizations = []
    let roles = []

    getUsers().subscribe(user => users = [...users, user]);
    getOrganizations().subscribe(organization => organizations = [...organizations, organization]);
    getRoles().subscribe(role => roles = [...roles, role]);
</script>

<svelte:head><title>Axces2 - Users</title></svelte:head>

<div class="container-fluid">
    <div class="row page-titles">
        <div class="col-md-5 col-8 align-self-center">
            <h3 class="text-themecolor">Users</h3>
            <ol class="breadcrumb">

                <li class="breadcrumb-item">Admin</li>
                <li class="breadcrumb-item active">Users</li>
            </ol>
        </div>
    </div>

    <section>
        <div class="card-group">
            <div class="card">
                <div class="card-body">
                    <div class="month-table">
                        <div class="table-responsive mt-3">
                            <table class="table stylish-table mb-0">
                                <thead>
                                <tr>
                                    <th>Email</th>
                                    <th>Organisation</th>
                                    <th>Role</th>
                                </tr>
                                </thead>
                                <tbody>
                                {#if organizations.length > 0 && roles.length > 0 }
                                    {#each users as user, i(user.id)}
                                        <UserItem user={user} organizations={organizations} roles={roles}/>
                                    {/each}
                                {/if}
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
</div>
